export default "__VITE_PUBLIC_ASSET__164112c9__"